import { useState, useEffect, useCallback } from 'react'
import CoursesCard from '../../components/CoursesCard/CoursesCard'
import Loader from '../../components/Loader/Loader'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'

const AllCourses = () => {
  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('');

  const fetchCourses = useCallback(async () => {
    setLoading(true)
    const res = await fetch(`${process.env.REACT_APP_API}/course/exploreall`)
    const data = await res.json()
    setCourses(data)
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchCourses()
    return () => {
      setCourses([])
    }
  }, [fetchCourses])

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredCourses = courses.filter((course) => {
    return course.name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <>
      <Loader active={loading} />
      <Navbar />
      <div className="flex justify-center items-center flex-col p-4 pt-20">
        <div className="leading-relaxed text-center text-3xl p-4">
          ALL COURSES
        </div>
        <hr className="w-1/4 border-b-2 border-gray-400"></hr>
      </div>
      <div className="flex justify-center">
        <div className="flex w-80">
          <input
            type="text"
            className="block w-full px-4 py-2 text-purple-700 bg-white border rounded-full focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearch}
          />
          <button className="px-4 text-white bg-purple-600 rounded-full ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        id="Courses"
        className="flex justify-center items-center mx-auto my-4 flex-col p-10"
      >
        <div className="grid grid-flow-row gap-10 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-8">
          {filteredCourses.map(({ imgUrl, name, category, _id }, index) => (
            <CoursesCard
              key={`${name}${index}`}
              imgUrl={imgUrl}
              courseName={name}
              courseDetail={category}
              courseId={_id}
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AllCourses
